export * from './src/enterprise-web-five-v1-icon-icons.universal.js';
